import api from "@services/apiList";
import instance from "@services/services";
import { notifyAiWalletRefresh } from "../context/AiWallet/aiWalletEvents";
import type { ResponseType } from "../Types/ServicesType/servicesType";
import type {
  VoicePromptRequest,
  VoicePromptResponseBody,
} from "../Types/VoiceAssistant/VoiceAssistantTypes";

export const voicePromptService = async (
  payload: VoicePromptRequest,
): Promise<ResponseType<VoicePromptResponseBody>> => {
  const result = await instance.post(api.voiceAssistantApi.prompt, payload);
  const data = result.data as ResponseType<VoicePromptResponseBody>;
  if (data.responseIndicator === "success") {
    notifyAiWalletRefresh();
  }
  return data;
};
